import {
  IInvitePeopleParams,
  IDateTimeParams,
  ILocationParams,
  IFeedBackParams, ILoggedTimeParams,
} from 'modules/params/param.type';
import { apiCall } from 'store/services/service';
import {
  URL_INVITE_PEOPLE,
  URL_NOTIFICATION_SETTING,
  URL_DATE_TIME_FORMAT,
  URL_SET_LOCATION,
  URL_FEEDBACK,
  URL_SET_LOGGED_TIME,
  URL_NOTIFICATION,
  URL_ADMIN_BROADCASTS,
} from './URL';

export const api = {
  invitePeopleRequest(params: IInvitePeopleParams) {
    return apiCall.post({ url: URL_INVITE_PEOPLE, isAuthToken: true, params });
  },
  feedBackRequest(params: IFeedBackParams) {
    return apiCall.post({ url: URL_FEEDBACK, isAuthToken: true, params });
  },
  notificationSettingRequest() {
    return apiCall.get({ url: URL_NOTIFICATION_SETTING, isAuthToken: true, params : {} });
  },
  updateNotificationSettingRequest() {
    return apiCall.post({ url: URL_NOTIFICATION_SETTING, isAuthToken: true, params : {} });
  },
  dateTimeSettingRequest() {
    return apiCall.get({ url: URL_DATE_TIME_FORMAT, isAuthToken: true, params : {} });
  },
  updateDateTimeSettingRequest(params: IDateTimeParams) {
    return apiCall.post({ url: URL_DATE_TIME_FORMAT, isAuthToken: true, params });
  },
  createLocationRequest(params: ILocationParams) {
    return apiCall.post({ url: URL_SET_LOCATION, isAuthToken: true, params });
  },
  setLoggedTimeRequest(params: ILoggedTimeParams) {
    return apiCall.post({ url: URL_SET_LOGGED_TIME, isAuthToken: true, params });
  },
  // Admin broadcast messages shown in the dashboard "Admin Messages" panel.
  adminMessagesRequest() {
    return apiCall.get({ url: `${URL_NOTIFICATION}?type=admin`, isAuthToken: true, params: {} });
  },
  // Public Home: latest mass-mail broadcasts (no auth / no per-user read state).
  publicAdminBroadcastsRequest() {
    return apiCall.get({ url: URL_ADMIN_BROADCASTS, isAuthToken: false, params: {} });
  },
  // Mark a single admin message read ({ pk }), or all admin messages read ({ type: 'admin' }).
  markNotificationReadRequest(params: { pk?: number; type?: string }) {
    return apiCall.post({ url: URL_NOTIFICATION, isAuthToken: true, params });
  },
};

export default api;
